/** How a client-side feature flag evaluation settled. */
export type FeatureFlagResolutionReason =
  | 'resolved'
  | 'error'
  | 'timeout'
  | 'disabled';

/** Builder boot telemetry reasons (PostHog-disabled resolves immediately off-route). */
export type BuilderFlagSettleReason = Exclude<
  FeatureFlagResolutionReason,
  'disabled'
>;

export interface FeatureFlagResolvedState {
  enabled: boolean;
  isResolved: boolean;
  resolutionReason?: FeatureFlagResolutionReason;
}

export function featureFlagResolved(
  enabled: boolean,
  resolutionReason: FeatureFlagResolutionReason
): FeatureFlagResolvedState {
  return { enabled, isResolved: true, resolutionReason };
}

export function toBuilderFlagSettleReason(
  resolutionReason: FeatureFlagResolutionReason | undefined
): BuilderFlagSettleReason {
  if (resolutionReason === 'error') return 'error';
  if (resolutionReason === 'timeout') return 'timeout';
  return 'resolved';
}
